import axios from 'axios'

var TEXTIN_APP_ID = process.env.VUE_APP_TEXTIN_APP_ID || ''
var TEXTIN_SECRET_CODE = process.env.VUE_APP_TEXTIN_SECRET_CODE || ''

var textinClient = axios.create({
  baseURL: 'https://api.textin.com/ai/service/v1',
  timeout: 60000
})

function removeWatermark(imageData, alphaChannel) {
  console.log('removeWatermark called:', { imageDataType: typeof imageData, isUint8Array: imageData instanceof Uint8Array, alphaChannel })
  
  var headers = {
    'x-ti-app-id': TEXTIN_APP_ID,
    'x-ti-secret-code': TEXTIN_SECRET_CODE
  }
  
  var url = '/image/watermark_remove'
  if (alphaChannel !== undefined && alphaChannel !== null) {
    url += '?alpha_channel=' + alphaChannel
  }
  
  console.log('API URL:', url, 'Headers:', headers)
  
  if (typeof imageData === 'string' && (imageData.startsWith('http://') || imageData.startsWith('https://'))) {
    headers['Content-Type'] = 'text/plain'
    return textinClient.post(url, imageData, { headers: headers })
  } else {
    headers['Content-Type'] = 'application/octet-stream'
    return textinClient.post(url, imageData, { 
      headers: headers,
      responseType: 'json'
    })
  }
}

function cropEnhanceImage(imageData, options) {
  var opts = options || {}
  var enhanceMode = opts.enhanceMode !== undefined ? opts.enhanceMode : -1
  var cropImage = opts.cropImage !== undefined ? opts.cropImage : 1
  var dewarpImage = opts.dewarpImage !== undefined ? opts.dewarpImage : 1
  var deblurImage = opts.deblurImage !== undefined ? opts.deblurImage : 0
  var onlyPosition = opts.onlyPosition !== undefined ? opts.onlyPosition : 0
  
  var headers = {
    'x-ti-app-id': TEXTIN_APP_ID,
    'x-ti-secret-code': TEXTIN_SECRET_CODE,
    'Content-Type': 'application/octet-stream'
  }
  
  var params = []
  params.push('enhance_mode=' + enhanceMode)
  params.push('crop_image=' + cropImage)
  params.push('dewarp_image=' + dewarpImage)
  params.push('deblur_image=' + deblurImage)
  params.push('only_position=' + onlyPosition)
  
  var url = '/crop_enhance_image?' + params.join('&')
  
  return textinClient.post(url, imageData, { 
    headers: headers,
    responseType: 'json'
  })
}

function handwrittenErase(imageData, options) {
  var opts = options || {}
  var crop = opts.crop !== undefined ? opts.crop : 0
  var cropPosition = opts.cropPosition || ''
  var docDirection = opts.docDirection !== undefined ? opts.docDirection : 0
  var maskPosition = opts.maskPosition || ''
  var dewarp = opts.dewarp !== undefined ? opts.dewarp : 0
  
  var headers = {
    'x-ti-app-id': TEXTIN_APP_ID,
    'x-ti-secret-code': TEXTIN_SECRET_CODE,
    'Content-Type': 'application/octet-stream'
  }
  
  var params = []
  params.push('crop=' + crop)
  if (cropPosition) params.push('crop_position=' + encodeURIComponent(cropPosition))
  params.push('doc_direction=' + docDirection)
  if (maskPosition) params.push('mask_position=' + encodeURIComponent(maskPosition))
  params.push('dewarp=' + dewarp)
  
  var url = '/handwritten_erase?' + params.join('&')
  
  return textinClient.post(url, imageData, { 
    headers: headers,
    responseType: 'json'
  })
}

/* ========== 文档格式转换（自有服务器） ========== */

// 文档转换服务器地址（开发环境留空走代理，生产环境直连）
var DOC_CONVERT_BASE_URL = process.env.VUE_APP_DOC_CONVERT_BASE_URL || ''

var docConvertClient = axios.create({
  baseURL: DOC_CONVERT_BASE_URL || undefined,
  timeout: 120000
})

// 文档转换工具配置
var DOC_CONVERT_TOOLS = {
  'pdf-to-word': {
    endpoint: '/ai/service/v1/file-convert/pdf-to-word',
    accept: '.pdf',
    acceptMime: 'application/pdf',
    outputExt: '.docx',
    outputType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  },
  'image-to-word': {
    endpoint: '/ai/service/v1/file-convert/image-to-word',
    accept: '.jpg,.jpeg,.png,.bmp',
    acceptMime: 'image/*',
    outputExt: '.docx',
    outputType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    resultKey: 'docx'
  },
  'pdf-to-excel': {
    endpoint: '/ai/service/v1/file-convert/pdf-to-excel',
    textinEndpoint: '/file-convert/pdf-to-excel',
    accept: '.pdf',
    acceptMime: 'application/pdf',
    outputExt: '.xlsx',
    outputType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    useTextin: true
  },
  'pdf-to-ppt': {
    endpoint: '/ai/service/v1/file-convert/pdf-to-ppt',
    textinEndpoint: '/file-convert/pdf-to-ppt',
    accept: '.pdf',
    acceptMime: 'application/pdf',
    outputExt: '.pptx',
    outputType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    useTextin: true
  },
  'pdf-to-image': {
    endpoint: '/ai/service/v1/file-convert/pdf-to-image',
    accept: '.pdf',
    acceptMime: 'application/pdf',
    outputExt: '.zip',
    outputType: 'application/zip'
  },
  'word-to-pdf': {
    endpoint: '/ai/service/v1/file-convert/word-to-pdf',
    accept: '.doc,.docx',
    acceptMime: '.doc,.docx',
    outputExt: '.pdf',
    outputType: 'application/pdf'
  },
  'excel-to-pdf': {
    endpoint: '/ai/service/v1/file-convert/excel-to-pdf',
    accept: '.xls,.xlsx',
    acceptMime: '.xls,.xlsx',
    outputExt: '.pdf',
    outputType: 'application/pdf'
  },
  'image-to-pdf': {
    endpoint: '/ai/service/v1/file-convert/image-to-pdf',
    accept: '.jpg,.jpeg,.png,.bmp',
    acceptMime: 'image/*',
    outputExt: '.pdf',
    outputType: 'application/pdf',
    isImageToPdf: true
  },
  'word-to-image': {
    endpoint: '/ai/service/v1/file-convert/word-to-image',
    accept: '.doc,.docx',
    acceptMime: '.doc,.docx',
    outputExt: '.zip',
    outputType: 'application/zip'
  }
}

// 根据工具配置选择 client 和认证头
function getConvertClient(tool) {
  if (tool.useTextin) {
    return {
      client: textinClient,
      headers: {
        'x-ti-app-id': TEXTIN_APP_ID,
        'x-ti-secret-code': TEXTIN_SECRET_CODE
      }
    }
  }
  return {
    client: docConvertClient,
    headers: {}
  }
}

/**
 * 通用文档格式转换（二进制流上传）
 * @param {string} toolId - 工具 ID，对应 DOC_CONVERT_TOOLS 的 key
 * @param {Uint8Array|ArrayBuffer} fileData - 文件二进制数据
 * @returns {Promise} 响应数据
 */
function convertFile(toolId, fileData) {
  var tool = DOC_CONVERT_TOOLS[toolId]
  if (!tool) return Promise.reject(new Error('未知的转换工具: ' + toolId))

  var ctx = getConvertClient(tool)
  ctx.headers['Content-Type'] = 'application/octet-stream'
  var endpoint = tool.useTextin ? tool.textinEndpoint : tool.endpoint

  return ctx.client.post(endpoint, fileData, { headers: ctx.headers })
}

/**
 * 图片转 PDF（请求格式不同：JSON + base64 数组）
 * @param {string[]} base64Array - 图片 base64 编码数组（不含 data:image/xxx;base64, 前缀）
 * @returns {Promise} 响应数据
 */
function imageToPdf(base64Array) {
  var headers = {
    'Content-Type': 'application/json'
  }

  return docConvertClient.post(
    '/ai/service/v1/file-convert/image-to-pdf',
    { files: base64Array },
    { headers: headers }
  )
}

/**
 * 通过 URL 进行文档格式转换
 * @param {string} toolId - 工具 ID
 * @param {string} fileUrl - 在线文件 URL
 * @returns {Promise} 响应数据
 */
function convertFileByUrl(toolId, fileUrl) {
  var tool = DOC_CONVERT_TOOLS[toolId]
  if (!tool) return Promise.reject(new Error('未知的转换工具: ' + toolId))

  var ctx = getConvertClient(tool)
  ctx.headers['Content-Type'] = 'text/plain'
  var endpoint = tool.useTextin ? tool.textinEndpoint : tool.endpoint

  return ctx.client.post(endpoint, fileUrl, { headers: ctx.headers })
}

export { removeWatermark, cropEnhanceImage, handwrittenErase, DOC_CONVERT_TOOLS, convertFile, imageToPdf, convertFileByUrl }
export default { removeWatermark, cropEnhanceImage, handwrittenErase, DOC_CONVERT_TOOLS, convertFile, imageToPdf, convertFileByUrl }
